import { StatesService } from '@festina/collcalc-general-types/collcalc/services/StatesService'
import { useFestinaMutation } from '@festina-life/authentication'
import type { Except } from '@festina-life/core'

const method = StatesService.collCalcStateServicePostAdvanceCcState
type MethodParam = Parameters<typeof method>[0]

export const useSubmitAdvanceCcState = ({ tenantId }: { tenantId: string }) =>
  useFestinaMutation({
    component: 'collCalc',
    roles: StatesService.collCalcStateServicePostAdvanceCcState_roles,
    isScenario: false,
    mutateFunction: async (arg: Except<MethodParam, 'xTenantId'>) =>
      await method({ xTenantId: tenantId, ...arg }),
  })
